import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Sidebar";
import TopNavbar from "../../top-navbar/TopNav";
import "./PayslipBankUpload.css";
import { verifyPayslipBank } from "../../../services/employee/api";

export default function PayslipBankUpload() {
  const navigate = useNavigate();

  const [payslip, setPayslip] = useState(null);
  const [bankStatement, setBankStatement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("bgc_token");

  if (!token) {
    setError("Authentication token not found. Please log in.");
    setLoading(false);
    return;
  }

  const validateFile = (file) => {
    const allowedTypes = ["application/pdf"];
    const maxSize = 5 * 1024 * 1024; // 5 MB

    if (!allowedTypes.includes(file.type)) {
      alert("Only PDF files are allowed.");
      return false;
    }
    if (file.size > maxSize) {
      alert("File size must be less than 5 MB.");
      return false;
    }
    return true;
  };

  const handlePayslipChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setPayslip(file);
    } else {
      e.target.value = "";
    }
  };

  const handleBankChange = (e) => {
    const file = e.target.files[0];
    if (file && validateFile(file)) {
      setBankStatement(file);
    } else {
      e.target.value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!payslip || !bankStatement) {
      alert("Please upload both payslip and bank statement.");
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    const formData = new FormData();
    formData.append("payslip", payslip);
    formData.append("bankStatement", bankStatement);

    try {
      const response = await verifyPayslipBank(formData);
      setResult(response.data);
    } catch (err) {
      setError(err.response?.data || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    navigate("/employee/aiModules");
  };

  return (
    <div className="emp-dashboard-container">
      <Sidebar />

      <div className="emp-main-panel">
        <TopNavbar />

        <div className="upload-wrapper">
          <div className="upload-card">
            <div className="upload-header">
              <button className="back-btn" onClick={handleBack}>
                ← Back
              </button>
              <h2 className="upload-title">
                Payslip & Bank Statement Verification
              </h2>
            </div>

            <form onSubmit={handleSubmit} className="upload-form">
              <div className="file-group">
                <label className="file-label">Upload Payslip (PDF only)</label>
                <label className="custom-file-upload">
                  {payslip ? payslip.name : "Choose a file"}
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={handlePayslipChange}
                  />
                </label>
              </div>

              <div className="file-group">
                <label className="file-label">
                  Upload Bank Statement (PDF only)
                </label>
                <label className="custom-file-upload">
                  {bankStatement ? bankStatement.name : "Choose a file"}
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={handleBankChange}
                  />
                </label>
              </div>

              <button type="submit" className="btn" disabled={loading}>
                {loading ? "Verifying..." : "Verify"}
              </button>
            </form>

            {result && (
              <div className="result-card success">
                <h3>Verification Result</h3>
                <p>
                  <strong>Net Pay Matches Bank:</strong>{" "}
                  <span className={result.netPayMatchesBank ? "yes" : "no"}>
                    {result.netPayMatchesBank ? "Yes" : "No"}
                  </span>
                </p>
                <p>
                  <strong>Raw Amount Line:</strong>{" "}
                  {result.rawAmountLine || "—"}
                </p>
                <p>
                  <strong>Cleaned Words:</strong> {result.cleanedWords || "—"}
                </p>
                <p>
                  <strong>Extracted Net Pay:</strong> ₹
                  {result.extractedNetPay ?? "0"}
                </p>
                <p>
                  <strong>Matched Value:</strong> ₹
                  {result.matchedValue ?? "0.0"}
                </p>
                {result.matchedTransactionLine && (
                  <p>
                    <strong>Matched Transaction Line:</strong>{" "}
                    {result.matchedTransactionLine}
                  </p>
                )}
              </div>
            )}

            {error && (
              <div className="result-card error">
                ❌{" "}
                {typeof error === "string"
                  ? error
                  : JSON.stringify(error, null, 2)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
